/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Account
 * API для управления аккаунтами пользователей в HR Recruiter системе.  **Основные возможности:** - CRUD операции для аккаунтов - Фильтрация по компаниям (SaaS-архитектура) - Ролевая модель доступа  **Роли и права доступа:** - **SUPER_ADMIN**: полный доступ ко всем аккаунтам всех компаний - **OWNER**: управление аккаунтами своей компании, может управлять ADMIN - **ADMIN**: управление аккаунтами своей компании - **RECRUITER**: доступ только к своему аккаунту  **Изоляция данных:** - Каждая компания видит только своих пользователей - Автоматическая привязка к компании при создании аккаунтов 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hrrecruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccountResponse
 */
export interface AccountResponse {
    /**
     * ID пользователя
     * @type {number}
     * @memberof AccountResponse
     */
    'id': number;
    /**
     * Email пользователя
     * @type {string}
     * @memberof AccountResponse
     */
    'email': string;
    /**
     * Имя пользователя
     * @type {string}
     * @memberof AccountResponse
     */
    'firstName': string;
    /**
     * Фамилия пользователя
     * @type {string}
     * @memberof AccountResponse
     */
    'lastName': string;
    /**
     * URL аватара
     * @type {string}
     * @memberof AccountResponse
     */
    'avatarUrl'?: string | null;
    /**
     * Язык интерфейса
     * @type {string}
     * @memberof AccountResponse
     */
    'language'?: string;
    /**
     * Роль пользователя
     * @type {string}
     * @memberof AccountResponse
     */
    'role': AccountResponseRole;
    /**
     * ID команды
     * @type {number}
     * @memberof AccountResponse
     */
    'teamId'?: number | null;
    /**
     * ID компании, к которой принадлежит аккаунт.  **Видимость:** - **SUPER_ADMIN**: видит companyId всех аккаунтов - **ADMIN/RECRUITER**: companyId скрыт (null) для безопасности 
     * @type {number}
     * @memberof AccountResponse
     */
    'companyId'?: number | null;
    /**
     * Активен ли пользователь
     * @type {boolean}
     * @memberof AccountResponse
     */
    'isActive': boolean;
    /**
     * Дата создания
     * @type {string}
     * @memberof AccountResponse
     */
    'createdAt'?: string;
    /**
     * Дата обновления
     * @type {string}
     * @memberof AccountResponse
     */
    'updatedAt'?: string;
}

export const AccountResponseRole = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    RECRUITER: 'RECRUITER'
} as const;

export type AccountResponseRole = typeof AccountResponseRole[keyof typeof AccountResponseRole];

/**
 * 
 * @export
 * @interface AccountsPaginatedResponse
 */
export interface AccountsPaginatedResponse {
    /**
     * Список аккаунтов на текущей странице
     * @type {Array<AccountResponse>}
     * @memberof AccountsPaginatedResponse
     */
    'content': Array<AccountResponse>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof AccountsPaginatedResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof AccountsPaginatedResponse
     */
    'totalPages': number;
    /**
     * Номер текущей страницы (начиная с 0)
     * @type {number}
     * @memberof AccountsPaginatedResponse
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof AccountsPaginatedResponse
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface AuthResponse
 */
export interface AuthResponse {
    /**
     * JWT токен для авторизации
     * @type {string}
     * @memberof AuthResponse
     */
    'token': string;
    /**
     * 
     * @type {AccountResponse}
     * @memberof AuthResponse
     */
    'user': AccountResponse;
}
/**
 * Запрос на создание нового аккаунта пользователя.  **Ограничения по роли создателя:** - **SUPER_ADMIN**: может создавать аккаунты с любой ролью для любой компании - **ADMIN**: может создавать только RECRUITER в своей компании - **RECRUITER**: не может создавать аккаунты  **Управление компанией:** - **SUPER_ADMIN**: может указать companyId для создания аккаунта в любой компании - **ADMIN**: companyId игнорируется, аккаунт создается в компании создателя 
 * @export
 * @interface CreateAccountRequest
 */
export interface CreateAccountRequest {
    /**
     * Email пользователя
     * @type {string}
     * @memberof CreateAccountRequest
     */
    'email': string;
    /**
     * Имя пользователя
     * @type {string}
     * @memberof CreateAccountRequest
     */
    'firstName': string;
    /**
     * Фамилия пользователя
     * @type {string}
     * @memberof CreateAccountRequest
     */
    'lastName': string;
    /**
     * Пароль пользователя
     * @type {string}
     * @memberof CreateAccountRequest
     */
    'password': string;
    /**
     * Роль пользователя в системе.  **Ограничения по роли создателя:** - **SUPER_ADMIN**: может создавать аккаунты с любой ролью - **ADMIN**: может создавать только RECRUITER - **RECRUITER**: не может создавать аккаунты 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    'role': CreateAccountRequestRole;
    /**
     * ID компании для создания аккаунта.  **Права доступа:** - **SUPER_ADMIN**: может указать любую компанию - **ADMIN**: параметр игнорируется, аккаунт создается в компании создателя 
     * @type {number}
     * @memberof CreateAccountRequest
     */
    'companyId'?: number | null;
    /**
     * ID команды
     * @type {number}
     * @memberof CreateAccountRequest
     */
    'teamId'?: number | null;
    /**
     * Язык интерфейса
     * @type {string}
     * @memberof CreateAccountRequest
     */
    'language'?: string;
}

export const CreateAccountRequestRole = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    RECRUITER: 'RECRUITER'
} as const;

export type CreateAccountRequestRole = typeof CreateAccountRequestRole[keyof typeof CreateAccountRequestRole];

/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * Email пользователя
     * @type {string}
     * @memberof LoginRequest
     */
    'email': string;
    /**
     * Пароль пользователя
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
    /**
     * Запомнить меня — токен действует 30 дней вместо 24 часов
     * @type {boolean}
     * @memberof LoginRequest
     */
    'rememberMe'?: boolean;
}
/**
 * Базовый класс для всех пагинированных ответов
 * @export
 * @interface PaginatedResponse
 */
export interface PaginatedResponse {
    /**
     * Список элементов на текущей странице
     * @type {Array<object>}
     * @memberof PaginatedResponse
     */
    'content': Array<object>;
    /**
     * Общее количество элементов
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalElements': number;
    /**
     * Общее количество страниц
     * @type {number}
     * @memberof PaginatedResponse
     */
    'totalPages': number;
    /**
     * Номер текущей страницы (начиная с 0)
     * @type {number}
     * @memberof PaginatedResponse
     */
    'number': number;
    /**
     * Размер страницы
     * @type {number}
     * @memberof PaginatedResponse
     */
    'size': number;
}
/**
 * Запрос на обновление аккаунта пользователя.  **Ограничения по роли обновляющего:** - **SUPER_ADMIN**: может обновлять аккаунты с любой ролью и менять компанию - **ADMIN**: может обновлять только аккаунты своей компании - **RECRUITER**: может обновлять только аккаунты своей компании 
 * @export
 * @interface UpdateAccountRequest
 */
export interface UpdateAccountRequest {
    /**
     * Имя пользователя
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    'firstName': string;
    /**
     * Фамилия пользователя
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    'lastName': string;
    /**
     * Email пользователя
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    'email'?: string;
    /**
     * Пароль пользователя
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    'password'?: string;
    /**
     * Роль пользователя в системе.  **Ограничения по роли обновляющего:** - **SUPER_ADMIN**: может устанавливать любую роль - **ADMIN**: может устанавливать только RECRUITER - **RECRUITER**: не может изменять роли 
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    'role'?: UpdateAccountRequestRole;
    /**
     * URL аватара
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    'avatarUrl'?: string | null;
    /**
     * Язык интерфейса
     * @type {string}
     * @memberof UpdateAccountRequest
     */
    'language'?: string;
    /**
     * Активен ли пользователь
     * @type {boolean}
     * @memberof UpdateAccountRequest
     */
    'isActive'?: boolean;
    /**
     * ID компании для привязки аккаунта.  **Ограничения по роли обновляющего:** - **SUPER_ADMIN**: может указать companyId для смены компании аккаунта - **ADMIN/RECRUITER**: поле игнорируется, компания остается неизменной 
     * @type {number}
     * @memberof UpdateAccountRequest
     */
    'companyId'?: number | null;
}

export const UpdateAccountRequestRole = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    RECRUITER: 'RECRUITER'
} as const;

export type UpdateAccountRequestRole = typeof UpdateAccountRequestRole[keyof typeof UpdateAccountRequestRole];


/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Создает новый аккаунт пользователя.  **Права доступа:** - SUPER_ADMIN: может создавать аккаунты с любой ролью для любой компании - ADMIN: может создавать только RECRUITER аккаунты в своей компании  **Управление компанией:** - **SUPER_ADMIN**: может указать companyId для создания аккаунта в любой компании - **ADMIN**: companyId игнорируется, аккаунт создается в компании создателя - Команда (teamId) должна принадлежать той же компании, что и аккаунт - Если команда не принадлежит компании аккаунта, аккаунт создается без команды 
         * @summary Создать новый аккаунт
         * @param {CreateAccountRequest} createAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: async (createAccountRequest: CreateAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAccountRequest' is not null or undefined
            assertParamExists('createAccount', 'createAccountRequest', createAccountRequest)
            const localVarPath = `/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Выполняет окончательное удаление аккаунта по ID (физическое удаление из базы данных). Если нужно временно отключить доступ без удаления — используйте обновление аккаунта с полем isActive.  **Права доступа:** - **SUPER_ADMIN**: может удалить любой аккаунт любой компании - **ADMIN**: может удалить только аккаунты своей компании - **RECRUITER**: не имеет права удалять аккаунты 
         * @summary Удалить аккаунт по ID
         * @param {number} id ID аккаунта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteAccountById', 'id', id)
            const localVarPath = `/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает информацию об аккаунте по ID с проверкой доступа.  **Права доступа:** - **SUPER_ADMIN**: может получить любой аккаунт любой компании - **ADMIN**: может получить только аккаунты своей компании - **RECRUITER**: может получить только аккаунты своей компании  **Безопасность:** - Автоматическая проверка принадлежности к компании - Возврат 404 если аккаунт не найден или нет доступа 
         * @summary Получить аккаунт по ID
         * @param {number} id ID аккаунта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAccountById', 'id', id)
            const localVarPath = `/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает информацию о текущем авторизованном пользователе
         * @summary Получить текущий аккаунт
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает список аккаунтов с пагинацией, поиском и фильтрацией по роли и компании.  **Фильтрация по компаниям (SaaS-архитектура):** - **SUPER_ADMIN**: видит все аккаунты всех компаний, может фильтровать по companyId - **ADMIN**: видит только аккаунты своей компании (companyId игнорируется) - **RECRUITER**: видит только аккаунты своей компании (companyId игнорируется)  **Поиск и фильтрация:** - Поиск по имени, фамилии или email - Фильтрация по роли (SUPER_ADMIN, ADMIN, RECRUITER) - Фильтрация по компании (только для SUPER_ADMIN) - Пагинация с настраиваемым размером страницы - Сортировка по любому полю 
         * @summary Получить список аккаунтов
         * @param {string} [search] Поиск по имени, фамилии или email
         * @param {ListAccountsRole} [role] Фильтрация по роли пользователя
         * @param {ListAccountsActive} [active] Фильтрация по статусу активности аккаунта. - ACTIVE: только активные - INACTIVE: только неактивные - ALL: все (активные и неактивные) 
         * @param {number} [companyId] Фильтрация по ID компании.  **Права доступа:** - **SUPER_ADMIN**: может фильтровать по любой компании - **ADMIN/RECRUITER**: может фильтровать только по своей компании (параметр игнорируется) 
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts: async (search?: string, role?: ListAccountsRole, active?: ListAccountsActive, companyId?: number, page?: number, size?: number, sort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет информацию об аккаунте по ID с проверкой доступа.  **Права доступа:** - **SUPER_ADMIN**: может обновить любой аккаунт любой компании - **ADMIN**: может обновить только аккаунты своей компании - **RECRUITER**: может обновить только аккаунты своей компании  **Возможности обновления:** - Личная информация (имя, фамилия, email) - Смена пароля - Обновление роли (только для SUPER_ADMIN) - Настройки профиля (аватар, язык) 
         * @summary Обновить аккаунт по ID
         * @param {number} id ID аккаунта
         * @param {UpdateAccountRequest} updateAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountById: async (id: number, updateAccountRequest: UpdateAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAccountById', 'id', id)
            // verify required parameter 'updateAccountRequest' is not null or undefined
            assertParamExists('updateAccountById', 'updateAccountRequest', updateAccountRequest)
            const localVarPath = `/account/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет информацию о текущем авторизованном пользователе
         * @summary Обновить текущий аккаунт
         * @param {UpdateAccountRequest} updateAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentAccount: async (updateAccountRequest: UpdateAccountRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateAccountRequest' is not null or undefined
            assertParamExists('updateCurrentAccount', 'updateAccountRequest', updateAccountRequest)
            const localVarPath = `/account/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAccountRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * Создает новый аккаунт пользователя.  **Права доступа:** - SUPER_ADMIN: может создавать аккаунты с любой ролью для любой компании - ADMIN: может создавать только RECRUITER аккаунты в своей компании  **Управление компанией:** - **SUPER_ADMIN**: может указать companyId для создания аккаунта в любой компании - **ADMIN**: companyId игнорируется, аккаунт создается в компании создателя - Команда (teamId) должна принадлежать той же компании, что и аккаунт - Если команда не принадлежит компании аккаунта, аккаунт создается без команды 
         * @summary Создать новый аккаунт
         * @param {CreateAccountRequest} createAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAccount(createAccountRequest: CreateAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(createAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.createAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Выполняет окончательное удаление аккаунта по ID (физическое удаление из базы данных). Если нужно временно отключить доступ без удаления — используйте обновление аккаунта с полем isActive.  **Права доступа:** - **SUPER_ADMIN**: может удалить любой аккаунт любой компании - **ADMIN**: может удалить только аккаунты своей компании - **RECRUITER**: не имеет права удалять аккаунты 
         * @summary Удалить аккаунт по ID
         * @param {number} id ID аккаунта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAccountById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccountById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.deleteAccountById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает информацию об аккаунте по ID с проверкой доступа.  **Права доступа:** - **SUPER_ADMIN**: может получить любой аккаунт любой компании - **ADMIN**: может получить только аккаунты своей компании - **RECRUITER**: может получить только аккаунты своей компании  **Безопасность:** - Автоматическая проверка принадлежности к компании - Возврат 404 если аккаунт не найден или нет доступа 
         * @summary Получить аккаунт по ID
         * @param {number} id ID аккаунта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountById(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getAccountById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает информацию о текущем авторизованном пользователе
         * @summary Получить текущий аккаунт
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getCurrentAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает список аккаунтов с пагинацией, поиском и фильтрацией по роли и компании.  **Фильтрация по компаниям (SaaS-архитектура):** - **SUPER_ADMIN**: видит все аккаунты всех компаний, может фильтровать по companyId - **ADMIN**: видит только аккаунты своей компании (companyId игнорируется) - **RECRUITER**: видит только аккаунты своей компании (companyId игнорируется)  **Поиск и фильтрация:** - Поиск по имени, фамилии или email - Фильтрация по роли (SUPER_ADMIN, ADMIN, RECRUITER) - Фильтрация по компании (только для SUPER_ADMIN) - Пагинация с настраиваемым размером страницы - Сортировка по любому полю 
         * @summary Получить список аккаунтов
         * @param {string} [search] Поиск по имени, фамилии или email
         * @param {ListAccountsRole} [role] Фильтрация по роли пользователя
         * @param {ListAccountsActive} [active] Фильтрация по статусу активности аккаунта. - ACTIVE: только активные - INACTIVE: только неактивные - ALL: все (активные и неактивные) 
         * @param {number} [companyId] Фильтрация по ID компании.  **Права доступа:** - **SUPER_ADMIN**: может фильтровать по любой компании - **ADMIN/RECRUITER**: может фильтровать только по своей компании (параметр игнорируется) 
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccounts(search?: string, role?: ListAccountsRole, active?: ListAccountsActive, companyId?: number, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountsPaginatedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccounts(search, role, active, companyId, page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.listAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет информацию об аккаунте по ID с проверкой доступа.  **Права доступа:** - **SUPER_ADMIN**: может обновить любой аккаунт любой компании - **ADMIN**: может обновить только аккаунты своей компании - **RECRUITER**: может обновить только аккаунты своей компании  **Возможности обновления:** - Личная информация (имя, фамилия, email) - Смена пароля - Обновление роли (только для SUPER_ADMIN) - Настройки профиля (аватар, язык) 
         * @summary Обновить аккаунт по ID
         * @param {number} id ID аккаунта
         * @param {UpdateAccountRequest} updateAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountById(id: number, updateAccountRequest: UpdateAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountById(id, updateAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateAccountById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет информацию о текущем авторизованном пользователе
         * @summary Обновить текущий аккаунт
         * @param {UpdateAccountRequest} updateAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCurrentAccount(updateAccountRequest: UpdateAccountRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCurrentAccount(updateAccountRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.updateCurrentAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * Создает новый аккаунт пользователя.  **Права доступа:** - SUPER_ADMIN: может создавать аккаунты с любой ролью для любой компании - ADMIN: может создавать только RECRUITER аккаунты в своей компании  **Управление компанией:** - **SUPER_ADMIN**: может указать companyId для создания аккаунта в любой компании - **ADMIN**: companyId игнорируется, аккаунт создается в компании создателя - Команда (teamId) должна принадлежать той же компании, что и аккаунт - Если команда не принадлежит компании аккаунта, аккаунт создается без команды 
         * @summary Создать новый аккаунт
         * @param {CreateAccountRequest} createAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount(createAccountRequest: CreateAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountResponse> {
            return localVarFp.createAccount(createAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Выполняет окончательное удаление аккаунта по ID (физическое удаление из базы данных). Если нужно временно отключить доступ без удаления — используйте обновление аккаунта с полем isActive.  **Права доступа:** - **SUPER_ADMIN**: может удалить любой аккаунт любой компании - **ADMIN**: может удалить только аккаунты своей компании - **RECRUITER**: не имеет права удалять аккаунты 
         * @summary Удалить аккаунт по ID
         * @param {number} id ID аккаунта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteAccountById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает информацию об аккаунте по ID с проверкой доступа.  **Права доступа:** - **SUPER_ADMIN**: может получить любой аккаунт любой компании - **ADMIN**: может получить только аккаунты своей компании - **RECRUITER**: может получить только аккаунты своей компании  **Безопасность:** - Автоматическая проверка принадлежности к компании - Возврат 404 если аккаунт не найден или нет доступа 
         * @summary Получить аккаунт по ID
         * @param {number} id ID аккаунта
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<AccountResponse> {
            return localVarFp.getAccountById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает информацию о текущем авторизованном пользователе
         * @summary Получить текущий аккаунт
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentAccount(options?: RawAxiosRequestConfig): AxiosPromise<AccountResponse> {
            return localVarFp.getCurrentAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает список аккаунтов с пагинацией, поиском и фильтрацией по роли и компании.  **Фильтрация по компаниям (SaaS-архитектура):** - **SUPER_ADMIN**: видит все аккаунты всех компаний, может фильтровать по companyId - **ADMIN**: видит только аккаунты своей компании (companyId игнорируется) - **RECRUITER**: видит только аккаунты своей компании (companyId игнорируется)  **Поиск и фильтрация:** - Поиск по имени, фамилии или email - Фильтрация по роли (SUPER_ADMIN, ADMIN, RECRUITER) - Фильтрация по компании (только для SUPER_ADMIN) - Пагинация с настраиваемым размером страницы - Сортировка по любому полю 
         * @summary Получить список аккаунтов
         * @param {string} [search] Поиск по имени, фамилии или email
         * @param {ListAccountsRole} [role] Фильтрация по роли пользователя
         * @param {ListAccountsActive} [active] Фильтрация по статусу активности аккаунта. - ACTIVE: только активные - INACTIVE: только неактивные - ALL: все (активные и неактивные) 
         * @param {number} [companyId] Фильтрация по ID компании.  **Права доступа:** - **SUPER_ADMIN**: может фильтровать по любой компании - **ADMIN/RECRUITER**: может фильтровать только по своей компании (параметр игнорируется) 
         * @param {number} [page] Номер страницы (начиная с 0)
         * @param {number} [size] Размер страницы
         * @param {string} [sort] Поле для сортировки
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts(search?: string, role?: ListAccountsRole, active?: ListAccountsActive, companyId?: number, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig): AxiosPromise<AccountsPaginatedResponse> {
            return localVarFp.listAccounts(search, role, active, companyId, page, size, sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет информацию об аккаунте по ID с проверкой доступа.  **Права доступа:** - **SUPER_ADMIN**: может обновить любой аккаунт любой компании - **ADMIN**: может обновить только аккаунты своей компании - **RECRUITER**: может обновить только аккаунты своей компании  **Возможности обновления:** - Личная информация (имя, фамилия, email) - Смена пароля - Обновление роли (только для SUPER_ADMIN) - Настройки профиля (аватар, язык) 
         * @summary Обновить аккаунт по ID
         * @param {number} id ID аккаунта
         * @param {UpdateAccountRequest} updateAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountById(id: number, updateAccountRequest: UpdateAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountResponse> {
            return localVarFp.updateAccountById(id, updateAccountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет информацию о текущем авторизованном пользователе
         * @summary Обновить текущий аккаунт
         * @param {UpdateAccountRequest} updateAccountRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCurrentAccount(updateAccountRequest: UpdateAccountRequest, options?: RawAxiosRequestConfig): AxiosPromise<AccountResponse> {
            return localVarFp.updateCurrentAccount(updateAccountRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * Создает новый аккаунт пользователя.  **Права доступа:** - SUPER_ADMIN: может создавать аккаунты с любой ролью для любой компании - ADMIN: может создавать только RECRUITER аккаунты в своей компании  **Управление компанией:** - **SUPER_ADMIN**: может указать companyId для создания аккаунта в любой компании - **ADMIN**: companyId игнорируется, аккаунт создается в компании создателя - Команда (teamId) должна принадлежать той же компании, что и аккаунт - Если команда не принадлежит компании аккаунта, аккаунт создается без команды 
     * @summary Создать новый аккаунт
     * @param {CreateAccountRequest} createAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public createAccount(createAccountRequest: CreateAccountRequest, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).createAccount(createAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Выполняет окончательное удаление аккаунта по ID (физическое удаление из базы данных). Если нужно временно отключить доступ без удаления — используйте обновление аккаунта с полем isActive.  **Права доступа:** - **SUPER_ADMIN**: может удалить любой аккаунт любой компании - **ADMIN**: может удалить только аккаунты своей компании - **RECRUITER**: не имеет права удалять аккаунты 
     * @summary Удалить аккаунт по ID
     * @param {number} id ID аккаунта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public deleteAccountById(id: number, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).deleteAccountById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает информацию об аккаунте по ID с проверкой доступа.  **Права доступа:** - **SUPER_ADMIN**: может получить любой аккаунт любой компании - **ADMIN**: может получить только аккаунты своей компании - **RECRUITER**: может получить только аккаунты своей компании  **Безопасность:** - Автоматическая проверка принадлежности к компании - Возврат 404 если аккаунт не найден или нет доступа 
     * @summary Получить аккаунт по ID
     * @param {number} id ID аккаунта
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getAccountById(id: number, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getAccountById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает информацию о текущем авторизованном пользователе
     * @summary Получить текущий аккаунт
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getCurrentAccount(options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).getCurrentAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает список аккаунтов с пагинацией, поиском и фильтрацией по роли и компании.  **Фильтрация по компаниям (SaaS-архитектура):** - **SUPER_ADMIN**: видит все аккаунты всех компаний, может фильтровать по companyId - **ADMIN**: видит только аккаунты своей компании (companyId игнорируется) - **RECRUITER**: видит только аккаунты своей компании (companyId игнорируется)  **Поиск и фильтрация:** - Поиск по имени, фамилии или email - Фильтрация по роли (SUPER_ADMIN, ADMIN, RECRUITER) - Фильтрация по компании (только для SUPER_ADMIN) - Пагинация с настраиваемым размером страницы - Сортировка по любому полю 
     * @summary Получить список аккаунтов
     * @param {string} [search] Поиск по имени, фамилии или email
     * @param {ListAccountsRole} [role] Фильтрация по роли пользователя
     * @param {ListAccountsActive} [active] Фильтрация по статусу активности аккаунта. - ACTIVE: только активные - INACTIVE: только неактивные - ALL: все (активные и неактивные) 
     * @param {number} [companyId] Фильтрация по ID компании.  **Права доступа:** - **SUPER_ADMIN**: может фильтровать по любой компании - **ADMIN/RECRUITER**: может фильтровать только по своей компании (параметр игнорируется) 
     * @param {number} [page] Номер страницы (начиная с 0)
     * @param {number} [size] Размер страницы
     * @param {string} [sort] Поле для сортировки
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public listAccounts(search?: string, role?: ListAccountsRole, active?: ListAccountsActive, companyId?: number, page?: number, size?: number, sort?: string, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).listAccounts(search, role, active, companyId, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет информацию об аккаунте по ID с проверкой доступа.  **Права доступа:** - **SUPER_ADMIN**: может обновить любой аккаунт любой компании - **ADMIN**: может обновить только аккаунты своей компании - **RECRUITER**: может обновить только аккаунты своей компании  **Возможности обновления:** - Личная информация (имя, фамилия, email) - Смена пароля - Обновление роли (только для SUPER_ADMIN) - Настройки профиля (аватар, язык) 
     * @summary Обновить аккаунт по ID
     * @param {number} id ID аккаунта
     * @param {UpdateAccountRequest} updateAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateAccountById(id: number, updateAccountRequest: UpdateAccountRequest, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateAccountById(id, updateAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет информацию о текущем авторизованном пользователе
     * @summary Обновить текущий аккаунт
     * @param {UpdateAccountRequest} updateAccountRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public updateCurrentAccount(updateAccountRequest: UpdateAccountRequest, options?: RawAxiosRequestConfig) {
        return AccountApiFp(this.configuration).updateCurrentAccount(updateAccountRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListAccountsRole = {
    SUPER_ADMIN: 'SUPER_ADMIN',
    OWNER: 'OWNER',
    ADMIN: 'ADMIN',
    RECRUITER: 'RECRUITER'
} as const;
export type ListAccountsRole = typeof ListAccountsRole[keyof typeof ListAccountsRole];
/**
 * @export
 */
export const ListAccountsActive = {
    ALL: 'ALL',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
} as const;
export type ListAccountsActive = typeof ListAccountsActive[keyof typeof ListAccountsActive];


/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Публичный endpoint для входа в систему. Доступен для всех ролей: admin, recruiter, viewer. Доступно без авторизации. Возвращает JWT токен для дальнейшей авторизации. 
         * @summary Вход пользователя (Публичный endpoint)
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Публичный endpoint для входа в систему. Доступен для всех ролей: admin, recruiter, viewer. Доступно без авторизации. Возвращает JWT токен для дальнейшей авторизации. 
         * @summary Вход пользователя (Публичный endpoint)
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Публичный endpoint для входа в систему. Доступен для всех ролей: admin, recruiter, viewer. Доступно без авторизации. Возвращает JWT токен для дальнейшей авторизации. 
         * @summary Вход пользователя (Публичный endpoint)
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuthResponse> {
            return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Публичный endpoint для входа в систему. Доступен для всех ролей: admin, recruiter, viewer. Доступно без авторизации. Возвращает JWT токен для дальнейшей авторизации. 
     * @summary Вход пользователя (Публичный endpoint)
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public login(loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).login(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



